import { useEffect, useState } from "react";
import ordersService from "services/orders.service";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function SelectOrder({
    changeHandler,
    selectedOrder,
    error
}) {
    const [orders, setOrders] = useState([]);
    const [selectedOrdId, setSelectedOrdId] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const ordsResponse = await ordersService.getOrders();
                const mapped = ordsResponse.data.attributes.map((m) => ({
                    id: m._id,
                    orderNum: m.order_num,
                    orgName: m.organization.name,
                }))
                setOrders(mapped);
            } catch (error) {
                console.error("Error fetching organizations: ", error);
            }
        })();
    }, [])

    useEffect(() => {
        if (selectedOrder && selectedOrder._id) {
            setSelectedOrdId(selectedOrder._id);
        }
    }, [selectedOrder]);

    // Handle organization selection change 
    const handleOrdChange = (e) => {
        const selectedId = e.target.value;
        setSelectedOrdId(selectedId);
        const selected = orders.find((o) => o.id === selectedId);
        const update = {
            order: selectedId,
            orderNum: selected?.orderNum ?? "",
            organizationName: selected?.orgName ?? "",
        };
        changeHandler(update);
    }

    return (
        <MDBox>
            <FormControl fullWidth>
                <InputLabel error={error} id="order-select-label">Order</InputLabel>
                <Select
                    label="Order"
                    labelId="organization-select-label"
                    variant="outlined"
                    name="order"
                    value={selectedOrdId}
                    onChange={handleOrdChange}
                    error={error}
                    helperText={error}
                    fullWidth
                    renderValue={(selected) => {
                        const found = orders.find((o) => o.id === selected);
                        return found ? found.orderNum : "";
                    }}
                    sx={{ height: '45px', maxWidth: '100%', '& .MuiSelect-select': { paddingY: '8px' } }}
                >
                    {orders.map((ord) => (
                        <MenuItem key={ord.id} value={ord.id}>
                            {ord.orderNum}
                        </MenuItem>
                    ))}
                </Select>
                {error && (
                        <MDTypography ml={2} mt={0.1} variant="caption" color="error">
                            {error}
                        </MDTypography>
                )}
            </FormControl>
        </MDBox>
    )
}